<template>
  <div class="explain">
    <div class="explain-warpper">
      <h1>拍摄说明</h1>
      <div class="pic-item">
        <h2>图片1：拍摄商店外景</h2>
        <img src="../../assets/images/example01/pic3.png" alt />
      </div>
      <div class="pic-item">
        <h2>图片2：拍摄香烟正面</h2>
        <img src="../../assets/images/example01/pic2.png" alt />
      </div>
      <div class="pic-item">
        <h2>图片3：拍摄香烟底面</h2>
        <img src="../../assets/images/example01/pic1.png" alt />
      </div>
    </div>
    <div class="footer">
      <button @click="back">返回举报界面</button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back: function () {
      this.$router.push("/tip")
    }
  }
}
</script>

<style lang="stylus" scoped>
.explain {
  color: #231815;
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: auto;

  .explain-warpper {
    min-height: 100%;
    margin-bottom: 2.777778rem;

    h1 {
      font-size: 0.652778rem;
      text-align: center;
      margin: 1.527778rem auto;
    }

    .pic-item {
      text-align: center;
      margin-bottom: 0.833333rem;

      h2 {
        font-size: 0.388889rem;
      }

      img {
        width: 2.777778rem;
        height: 2.138889rem;
        margin: 0.277778rem auto;
      }
    }
  }

  .footer {
    width: 100%;
    text-align: center;
    margin-top: -1.666667rem;

    button {
      border: none;
      background: transparent;
      color: #1B92D2;
      font-size: 0.5rem;
      border-bottom: 1px solid #1B92D2;
      padding: 0.138889rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/example01/explain.vue